import { useMemo }   from 'react';
import PrimaryButton from './primary_button';
import React         from 'react';
import useDialog     from '../hooks/use_dialog';

//  Confirm button appears in its own section (eg remove button)
//  and shows an confirm popup before perform action
//
//  label             - Text to be shown on button, and used for confirm dialog if confirmButtonText is not supplied
//  className         - class list to pass to button
//  danger            — If you're confirming something, it's probably dangerous, but there's an option for it not to be
//  fill              - Should be false, but some use cases may require it to be true
//  confirmTitle      - Shows in bold as the title of the dialog
//  confirmSubtitle   - Shows below bold title, good for providing further context to what they're confirming
//  confirmButtonText - What the user will see in the dialog, if not supplied, will fallback to the label
//  cancelButtonText  - What appears to the user if they want to cancel the action, defaults to "Keep"
//  onConfirm         - Callback for when customer confirms
export default function ConfirmButton({
  label,
  className,
  danger = true,
  fill = false,
  confirmTitle = 'Confirm',
  confirmSubtitle,
  confirmButtonText,
  onConfirm,
  cancelButtonText = 'Keep'
}) {
  const buttons = useMemo(() => ([
    {
      text:  cancelButtonText,
      color: 'blue',
      close: true
    },
    {
      text:    confirmButtonText || label,
      close:   true,
      bold:    true,
      color:   danger ? 'red' : 'blue',
      onClick: onConfirm
    }
  ]), [ confirmButtonText, cancelButtonText, label, onConfirm, danger ]);

  const onClick = useDialog({
    title:   confirmTitle,
    content: confirmSubtitle,
    buttons
  });

  return (
    <PrimaryButton {...{ label, className, danger, onClick, fill }}/>
  );
}
